import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddServicePart, IDeleteServicePart, IGetServicePart, IServicePart, IUpdateServicePart } from '../models/service-part';

@Injectable({
    providedIn: 'root'
})
export class ServicePartService {

    constructor(private http: HttpClient) { }

    addServicePart(request: IAddServicePart){
        return this.http.post<IServicePart>(
            `${environment.baseUrl}/v1/ServiceParts/createServicePart`,
            request
        )
    }

    deleteServicePart(request: IDeleteServicePart){
        return this.http.delete(
            `${environment.baseUrl}/v1/ServiceParts/deleteServicePart/${request.id}`
        )
    }

    updateServicePart(request: IUpdateServicePart){
        return this.http.put<IServicePart>(
            `${environment.baseUrl}/v1/ServiceParts/updateServicePart/${request.id}`,
            request
        )
    }
}